import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import INVENTORY_API_BASE_URL from "./api";

const apiOrigin = new URL(INVENTORY_API_BASE_URL).origin;

export async function getAccessToken() {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  if (!token) throw new Error("A signed-in session is required.");
  return token;
}

export async function apiFetch(input, options = {}) {
  const headers = new Headers(options.headers);
  headers.set("Authorization", `Bearer ${await getAccessToken()}`);
  return fetch(input, { ...options, headers });
}

axios.interceptors.request.use(async (config) => {
  let requestOrigin;
  try {
    requestOrigin = new URL(config.url, config.baseURL || window.location.origin).origin;
  } catch {
    return config;
  }

  if (requestOrigin === apiOrigin) {
    config.headers = config.headers || {};
    const authorization = `Bearer ${await getAccessToken()}`;
    if (typeof config.headers.set === "function") {
      config.headers.set("Authorization", authorization);
    } else {
      config.headers.Authorization = authorization;
    }
  }

  return config;
});
